export default {"src":"/_next/static/media/clock.9de27809.svg","height":800,"width":800};